import { render, staticRenderFns } from "./viewTrainings.vue?vue&type=template&id=3cc297be&scoped=true&"
import script from "./viewTrainings.vue?vue&type=script&lang=js&"
export * from "./viewTrainings.vue?vue&type=script&lang=js&"
import style0 from "./viewTrainings.vue?vue&type=style&index=0&id=3cc297be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc297be",
  null
  
)

export default component.exports